<div *ngIf="env.showBanner === 'true' " class="dsp-qa-banner">
  <span>DS Portal {{ env.banner }} {{ env.internal ? 'Admin' : 'Client' }} v{{ env.version }}</span>
</div>
